
import registrationOffices from './registrationOffices.json'

/**
 * German License Plate City Codes
 * Sourced dynamically from registration offices to ensure consistency
 */

// Extract unique region codes from registration offices
const OFFICE_CODES = Array.from(new Set(registrationOffices.map((o: any) => o.regionCode))).sort()

// Export as the definitive list
export const GERMAN_CITY_CODES = OFFICE_CODES

/**
 * Filter city codes by search term
 * Prioritizes exact matches and shows more results for 3-letter codes
 */
export function filterCityCodes(searchTerm: string): string[] {
  if (!searchTerm) return GERMAN_CITY_CODES.slice(0, 20) // Show first 20 by default

  const upperSearch = searchTerm.toUpperCase()
  const matching = GERMAN_CITY_CODES.filter(code => code.startsWith(upperSearch))

  // Sort: exact matches first, then by length (shorter first), then alphabetically
  const sorted = matching.sort((a, b) => {
    // Exact match priority
    if (a === upperSearch) return -1
    if (b === upperSearch) return 1
    // Length priority (shorter first)
    if (a.length !== b.length) return a.length - b.length
    // Alphabetical
    return a.localeCompare(b)
  })

  // Show more results for 3-letter codes (up to 15), otherwise 10
  const limit = upperSearch.length >= 2 ? 15 : 10
  return sorted.slice(0, limit)
}

/**
 * Check if a city code exists in the database
 */
export function isValidCityCode(cityCode: string): boolean {
  if (!cityCode) return false
  const upperCode = cityCode.toUpperCase()
  return GERMAN_CITY_CODES.includes(upperCode)
}
